// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_UM3","cls2":"CiterightLanding-cls2_67P CiterightLanding-cls1_UM3"};